module.exports = __webpack_public_path__ + "img/NHA_HANG.0deebe88.svg";